import Wrapper from "../../layouts/wrapper"

const Error404 = () => {
    return <Wrapper>
        <h1> Error 404: Page Not Found</h1>
    </Wrapper>
}

export default Error404;